import { useEffect, useMemo, useState } from 'react'
import { Navigate, useParams } from 'react-router'
import { SpinnerLoader } from 'shared/ui'
import { logger } from 'shared/lib'
import type { IResponseClickToText } from 'entities/ClickToText/api/type'
import { ClickToTextApi } from 'entities/ClickToText/api/clickToText'
import { useEntitiesContext } from 'entities/EntitiesExport'
import { ClickToTextRoutes } from 'pages/clickToText'
import { ClickToTextViewStore } from 'pages/clickToText/store'
import { useClickToTextPageContext } from 'pages/clickToText/context'
import { EditClickToTextView } from './EditClickToTextView'

const SuccessContent = ({
  clickToTextResponse,
  isDuplicate,
}: {
  clickToTextResponse: IResponseClickToText
  isDuplicate?: boolean
}) => {
  const entities = useEntitiesContext()
  const clickToTextPageStore = useClickToTextPageContext()
  const store = useMemo(
    () =>
      new ClickToTextViewStore(entities, clickToTextPageStore, clickToTextResponse, isDuplicate),
    []
  )
  return <EditClickToTextView store={store} />
}

type IEditClickToText = {
  isDuplicate?: boolean
}

export const EditClickToText = ({ isDuplicate }: IEditClickToText) => {
  const { id } = useParams()
  const [isLoading, setIsLoading] = useState(true)
  const [clickToTextResponse, setClickToTextResponse] = useState<IResponseClickToText | null>(null)

  useEffect(() => {
    if (id) {
      ClickToTextApi.getClickToTextById(id)
        .then((res) => {
          if (res) {
            setClickToTextResponse(res.data)
          }
        })
        .catch(logger.error)
        .finally(() => {
          setIsLoading(false)
        })
    }
  }, [id])

  if (isLoading) {
    return <SpinnerLoader ariaLabel={'EditClickToText'} />
  }
  if (clickToTextResponse) {
    return <SuccessContent clickToTextResponse={clickToTextResponse} isDuplicate={isDuplicate} />
  }
  return <Navigate to={`/${ClickToTextRoutes.root}`} />
}
